import React from 'react'
import { useState } from 'react';
import { FiEye, FiPrinter } from 'react-icons/fi';
import { Table } from '../../../../components/Tables/Table';
import { TableTotals } from '../../../../components/Tables/TableTotals';
import { icosIndicators } from '../../../../app/Paths';
import { useSelector } from 'react-redux';

export const Sales = () => {

  const [selectedItem, setSelectedItem] = useState(null);
  const { sales } = useSelector(state => state.customerDetail);
  const listSales = [...sales];

  let columns = [
    {
      header: 'FOLIO',
      dataIndex: 'FOLIO',
      classHeader: 'text-center',
      classRow: 'text-center',
      isTotal: false, // 👈 sumará esta columna
      renderer: (value, row) => (
        <>
          <button type="button" className="btn btn-link" onClick={() => { setSelectedItem(row.ID); }} >{value}</button>
        </>
      ),
    },
    {
      header: 'FECHA',
      dataIndex: 'FECHA_REGISTRO',
      classHeader: 'text-start',
      classRow: 'text-start',
      isTotal: false, // 👈 sumará esta columna
    },
    {
      header: 'TIPO DE COMPRA',
      dataIndex: 'TIPOVENTA',
      classHeader: 'text-center',
      classRow: 'text-center',
      isTotal: false, // 👈 sumará esta columna
    },

    // {
    //   header: 'CANT. PRODUCTOS',
    //   dataIndex: 'CANTIDAD_PRODUCTOS',
    //   classHeader: 'text-center',
    //   classRow: 'text-center',
    //   isTotal: false, // 👈 sumará esta columna
    // },
    // {
    //   header: 'SUBTOTAL',
    //   dataIndex: 'SUBTOTAL',
    //   classHeader: 'text-end',
    //   classRow: 'text-end',
    //   isTotal: true, // 👈 sumará esta columna
    //   renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    // },
    // {
    //   header: 'IVA',
    //   dataIndex: 'IVA',
    //   classHeader: 'text-center',
    //   classRow: 'text-center',
    //   isTotal: true, // 👈 sumará esta columna
    //   renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    // },
    {
      header: 'TOTAL',
      dataIndex: 'TOTAL',
      classHeader: 'text-center',
      classRow: 'text-center',
      isTotal: true, // 👈 sumará esta columna
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    // {
    //   header: 'PAGADO',
    //   dataIndex: 'MONTO_PAGADO',
    //   classHeader: 'text-center',
    //   classRow: 'text-center',
    //   isTotal: true, // 👈 sumará esta columna
    //   renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    // },
    {
      header: 'ACCIONES',
      dataIndex: 'ACTIVE',
      classHeader: 'text-center',
      classRow: 'text-center',
      isAction: true,
      renderer: (value, row) => {
        const isDeleted = Number(row.ACTIVE) === 0;
        return (
          <a href={`https://capacitacion.hdltechnology.com.mx/assets/reports/ordenVenta.html?folio=${row.FOLIO}&opcion=0`} target='blank' className="btn btn-outline-dark border-0" disabled={row.ACTIVE == 2} title="Ver / Editar">
            <FiPrinter size={18} />
          </a>
        );
      }
    }
  ];

  return (
    <div className='row'>

      <div className='col-12 mb-3'>
        <img src={icosIndicators['sales']} className="img-fluid" width={28} alt="sales" />
        <span className='ms-2 me-3 fw-bold h4'>Ventas</span>
      </div>

      <div className='col-12'>
        <TableTotals
          columns={columns}
          data={listSales}
          function_={(row) => { setSelectedItem(row.FOLIO) }}
          placeholderSearch="Buscar por: Folio, Fecha, Monto"
          showPagination={true}
          showControls={true}
          showTotals={true}
          countRow={true} // 👈 activa el contador de filas
          showAverage={false}  // 👈 activa fila de promedio
          msg={'No hay datos por mostrar'}
        />
      </div>
    </div>
  )
}
